import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { ResetEntityStyles } from 'src/editor/shared/settings/reset-entity-styles-button'
import { CouponInterface } from 'src/shared/entities/coupon/coupon.schema'
import Input from '../components/Input/Input'
import { useUpdatePropNew } from '../hooks/useUpdateProps'
import DeviceAppearanceNew from '../options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from '../options/HtmlAttrId'
import { FontSize } from '../styles'
import Border from '../styles/Border'

export default function CouponSettings({
  entity,
  defaultEntity,
}: {
  entity: CouponInterface
  defaultEntity?: CouponInterface
}) {
  const { isMobile } = useDeviceModeContext()

  const updateProp = useUpdatePropNew(entity)

  return (
    <>
      <GroupTitle
        withoutHorizontalLine
        afterChildren={
          defaultEntity && (
            <ResetEntityStyles
              entity={entity}
              defaultEntity={defaultEntity}
              keys={[
                ['field', 'placeholder'],
                ['field', 'fontSize'],
                ['field', 'color'],
                ['field', 'backgroundColor'],
                ['field', 'border'],
              ]}
              mobileKeys={[
                ['field', 'mobileFontSize'],
                ['field', 'mobileColor'],
                ['field', 'mobileBackgroundColor'],
                ['field', 'mobileBorder'],
              ]}
            />
          )
        }
      >
        entity_settings.coupon.field.group_title
      </GroupTitle>

      <Input
        label={'entity_settings.coupon.field.placeholder'}
        value={entity.field.placeholder}
        update={updateProp('field', 'placeholder')}
      />
      <FontSize
        update={updateProp('field', 'fontSize')}
        mobileUpdate={updateProp('field', 'mobileFontSize')}
        fontSize={entity.field.fontSize}
        mobileFontSize={entity.field.mobileFontSize}
      />
      <ColorPickerControl
        label="entity_settings.coupon.field.text_color"
        update={updateProp('field', 'color')}
        mobileUpdate={updateProp('field', 'mobileColor')}
        color={entity.field.color}
        mobileColor={entity.field.mobileColor}
      />
      <ColorPickerControl
        label="entity_settings.coupon.field.bg_color"
        update={updateProp('field', 'backgroundColor')}
        mobileUpdate={updateProp('field', 'mobileBackgroundColor')}
        color={entity.field.backgroundColor}
        mobileColor={entity.field.mobileBackgroundColor}
        isClearable
      />
      <Border
        update={updateProp('field', 'border')}
        border={entity.field.border}
        defaultBorder={defaultEntity?.field?.border}
        mobileDefaultBorder={defaultEntity?.field?.mobileBorder}
        mobileUpdate={updateProp('field', 'mobileBorder')}
        mobileBorder={entity.field.mobileBorder}
      />
      <GroupTitle>entity_settings.coupon.button.group_title</GroupTitle>
      <Input
        label="entity_settings.coupon.button.text"
        value={entity.button.text}
        update={updateProp('button', 'text')}
      />
      <FontSize
        update={updateProp('button', 'fontSize')}
        mobileUpdate={updateProp('button', 'mobileFontSize')}
        fontSize={entity.button.fontSize}
        mobileFontSize={entity.button.mobileFontSize}
      />
      <ColorPickerControl
        label="entity_settings.coupon.button.text_color"
        update={updateProp('button', 'color')}
        mobileUpdate={updateProp('button', 'mobileColor')}
        color={entity.button.color}
        mobileColor={entity.button.mobileColor}
      />
      <ColorPickerControl
        label="entity_settings.coupon.button.bg_color"
        update={updateProp('button', 'backgroundColor')}
        mobileUpdate={updateProp('button', 'mobileBackgroundColor')}
        color={entity.button.backgroundColor}
        mobileColor={entity.button.mobileBackgroundColor}
        isClearable
      />
      <Border
        update={updateProp('button', 'border')}
        border={entity.button.border}
        mobileUpdate={updateProp('button', 'mobileBorder')}
        mobileBorder={entity.button.mobileBorder}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
